import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import Breadcrumbs from 'Components/Utility/SEO/Breadcrumbs';
import bundleMessages from 'Components/Bundle/BundleMessages';

const messages = defineMessages({
  reviews: {
    id: 'bundle-breadcrumbs.reviews',
    defaultMessage: 'Reviews',
  },
});


const BundleBreadcrumbs = ({ product, isReviews, type, intl: { formatMessage } }) => {
  if (!product) {
    return false;
  }

  const crumbs = [];

  crumbs.push({
    label: formatMessage(bundleMessages.title),
    link: '/bundle',
  });

  let bundleType = '';

  switch (product.display_type) {
    case 'bundle':
      bundleType = 'games';
      break;
    case 'book-bundle':
    case 'elearning-bundle':
    case 'elearning':
    case 'comic-bundle':
      bundleType = 'books';
      break;
    case 'software-bundle':
    case 'audio-bundle':
    case 'video-bundle':
      bundleType = 'software';
      break;
    default:
      break;
  }

  if (bundleType && bundleMessages[`${bundleType}_title`]) {
    crumbs.push({
      label: formatMessage(bundleMessages[`${bundleType}_title`]),
      link: `/bundle/${bundleType}`,
    });
  }

  crumbs.push({
    label: product.name,
    link: `/${type || product.type}/${product.slug}`,
  });

  if (isReviews) {
    crumbs.push({
      label: formatMessage(messages.reviews),
      link: `/${product.type}/${product.slug}/reviews`,
    });
  }

  return <Breadcrumbs crumbs={crumbs} appearsOn={type} />;
};

export default injectIntl(BundleBreadcrumbs);

BundleBreadcrumbs.propTypes = {
  product: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  isReviews: PropTypes.bool,
};

BundleBreadcrumbs.defaultProps = {
  isReviews: false,
};
